import { FollowIcon } from 'components/icons';
import { Box, Typography } from '@mui/material';
import React, { ReactElement } from 'react';

export interface FollowButtonProps {
  following?: boolean;
  onClick?: () => void;
}

export const FollowButton = ({
  following = false,
  onClick,
}: FollowButtonProps): ReactElement => {
  return (
    <Box
      tabIndex={0}
      sx={{
        display: 'flex',
        height: '50px',
        padding: '0 8px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '4px',
        borderRadius: '10px',
        border: theme => `1px solid ${theme.palette.primary.main}`,
        background: theme => theme.palette.background.paper,
        cursor: 'pointer',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0,0,0,0)',
        lineHeight: 0,
        outline: 'none',
        '&:focus-visible': {
          outline: theme => `2px auto ${theme.palette.primary.main}`,
          outlineOffset: 6,
        },
      }}
      onKeyPress={(e: React.KeyboardEvent) => {
        if (e.key === ' ') {
          e.preventDefault();
          onClick?.();
        }
      }}
      onClick={onClick}
    >
      <Box display="flex" alignItems="center" gap="4px">
        {!following && (
          <Box sx={{ width: '20px', height: '20px' }}>
            <FollowIcon />
          </Box>
        )}
        <Typography
          sx={{ fontSize: 12, color: theme => theme.palette.primary.main }}
        >
          {following ? 'Following' : 'Follow'}
        </Typography>
      </Box>
    </Box>
  );
};
